// Member tutorial. Four screens, at Aithora Home's accessibility sizing.
//
// A member is somebody Aithora supports in their OWN HOME. They are not a resident: nobody
// runs their building, there are no care staff on a shift, and nothing here is anyone else's
// decision. That distinction drives every screen, because a member who thinks they are being
// monitored the way a facility resident is will switch it off.
//
// Same two rules as the resident and family tutorials: simplify, and no cheerfulness. Someone
// weighing up whether they can keep living at home is not helped by encouragement.
window.MEMBER_TUTORIAL = {
  role: 'Aithora Home',
  lead: 'Four things worth knowing.',

  screens: [
    {
      id: 'what',
      n: '1',
      title: 'This is your home',
      body: 'You are a member, not a resident. Nobody here manages your day, sets your routine, or needs to approve what you do. Aithora is help you can call on, in the house you already live in.',
      points: [
        'You decide what it does and when.',
        'Nobody is on a shift watching you.',
        'You can switch any of it off.',
      ],
      note: 'People in a facility are called residents, and their pages work differently because someone else is responsible for their care. Yours are yours.',
    },
    {
      id: 'ready',
      n: '2',
      title: 'What we look at',
      body: 'Four things decide whether staying at home keeps working: the house itself, whether help can reach you, your medications, and whether anyone would notice if something changed.',
      points: [
        'It is not about sensors.',
        'Each one has something you can actually do about it.',
        'We tell you which is weakest right now.',
      ],
      note: 'Most people want to stay at home and fewer believe it is realistic. The gap is usually these four things rather than health.',
    },
    {
      id: 'companion',
      n: '3',
      title: 'Someone to talk to',
      body: 'You can talk to Atlas whenever you like, day or night. It answers, and it remembers you, so you will not have to explain yourself twice.',
      points: [
        'Speak or type, whichever suits you.',
        'There is no right thing to say.',
        'Ask it what it remembers, any time.',
      ],
      note: 'If you would rather not use it, say so once and it will stop asking.',
    },
    {
      id: 'who',
      n: '4',
      title: 'Who else sees it',
      body: 'Nobody, until you say otherwise. If you want your daughter to see how you are doing, you turn that on, and you can turn it off again.',
      points: [
        'Everything starts switched off.',
        'You choose what each person sees.',
        'Changing your mind takes effect immediately.',
      ],
      note: 'The one thing it will not keep to itself is a serious worry about your safety. If you say something that suggests you are unwell or at risk, a person is told. That is the reason it is worth talking to.',
    },
  ],

  end: {
    title: 'That is everything',
    lines: [
      'Use it when you want to. Ignore it when you do not.',
      'It will still be here next week, and it will still remember.',
    ],
    ask: 'If you want any of this explained again, ask Atlas itself, or call the number on your welcome letter.',
    cta: 'Open my home',
  },
};
